import { render } from "./NewsNetwork.vue?vue&type=template&id=02b61ec2"
import script from "./NewsNetwork.vue?vue&type=script&lang=ts"
export * from "./NewsNetwork.vue?vue&type=script&lang=ts"

import "./NewsNetwork.vue?vue&type=style&index=0&id=02b61ec2&lang=scss"
script.render = render

export default script